

import React, { useState } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { AppBar, Toolbar, IconButton, Container } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  Typography,
  Divider,
} from "@mui/material";
// Company
import CompanyIndex from './components/pages/company/Index';
import CompanyCreate from "./components/pages/company/Create";
import CompanyEdit from "./components/pages/company/Edit";
// Branch
import BranchIndex from './components/pages/branch/Index';
import BranchCreate from "./components/pages/branch/Create";
import BranchEdit from "./components/pages/branch/Edit";
// Style
import StyleIndex from './components/pages/Style/Index';
import StyleCreate from "./components/pages/Style/Create";
import StyleEdit from "./components/pages/Style/Edit";
// Item Group
import BrandIndex from './components/pages/Brand/Index';
import BrandCreate from "./components/pages/Brand/Create";
import BrandEdit from "./components/pages/Brand/Edit";
// Item 
import ItemIndex from './components/pages/item/Index';
import ItemCreate from "./components/pages/item/Create";
import ItemEdit from "./components/pages/item/Edit";
//Master
import MasterIndex from "./components/pages/Master/Index";
import CapitalEdit from "./components/pages/Master/CapitalEdit";
//User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";
//Role
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";
//SalesMan
import SalesManCreate from "./components/pages/SalesMan/Create";
import SalesManIndex from "./components/pages/SalesMan/Index";
import SalesManEdit from "./components/pages/SalesMan/Edit";
//Purchase
import PurchaseIndex from "./components/pages/purchase/Index";
import PurchaseCreate from "./components/pages/purchase/Create";
import PurchaseEdit from "./components/pages/purchase/Edit";
import PurchaseDetails from "./components/pages/purchase/Details";
//---------------------NEW PURCHASE COMPONENTS---------------------
import NewPurchaseCreate from "./components/pages/purchase/NewCreate";
import NewPurchaseIndex from "./components/pages/purchase/NewIndex";
import NewPurchaseEdit from "./components/pages/purchase/NewEdit";
import NewPurchaseDetails from "./components/pages/purchase/NewDetails";
//PurchaseReturn
import PurchaseReturnIndex from "./components/pages/purchasereturn/Index";
import PurchaseReturnCreate from "./components/pages/purchasereturn/Create";
import PurchaseReturnEdit from "./components/pages/purchasereturn/Edit";
import PurchaseReturnDetails from "./components/pages/purchasereturn/Details";
//---------------------NEW PURCHASE COMPONENTS---------------------
import NewPurchaseReturnCreate from "./components/pages/purchasereturn/NewCreate";
import NewPurchaseReturnIndex from "./components/pages/purchasereturn/NewIndex";
import NewPurchaseReturnEdit from "./components/pages/purchasereturn/NewEdit";
import NewPurchaseReturnDetails from "./components/pages/purchasereturn/NewDetails";
//Sale
import SaleIndex from "./components/pages/sale/Index";
import SaleCreate from "./components/pages/sale/Create";
import SaleEdit from "./components/pages/sale/Edit";
import SaleDetails from "./components/pages/sale/Details";
//---------------------NEW SALE COMPONENTS---------------------
import NewSaleIndex from "./components/pages/sale/NewIndex";
import NewSaleCreate from "./components/pages/sale/NewCreate";
import NewSaleEdit from "./components/pages/sale/NewEdit";
import NewSaleDetails from "./components/pages/sale/NewDetails";
//Sale Return
import SaleReturnIndex from "./components/pages/salereturn/Index";
import SaleReturnCreate from "./components/pages/salereturn/Create";
import SaleReturnEdit from "./components/pages/salereturn/Edit";
import SaleReturnDetails from "./components/pages/salereturn/Details";
//Stock Transfer
import StockTransferIndex from "./components/pages/stocktransfer/Index";
import StockTransferCreate from "./components/pages/stocktransfer/Create";
import StockTransferEdit from "./components/pages/stocktransfer/Edit";
import StockIn from "./components/pages/stocktransfer/StockIn";
import StockInDetail from "./components/pages/stocktransfer/StockInDetail";
import StockTransferDetails from "./components/pages/stocktransfer/Details";
import StockInCreate from "./components/pages/stocktransfer/StockInCreate";
import StockTransferEcommCreate from "./components/pages/stocktransfer/EcommCreate";
import StockInPending from "./components/pages/stocktransfer/StockInPending";
// Replacement
import ReplacementIndex from "./components/pages/replacement/Index";
import ReplacementCreate from "./components/pages/replacement/Create";
import ReplacementEdit from "./components/pages/replacement/Edit";
import ReplacementDetails from "./components/pages/replacement/Details";
// Report
import DailySalesSummary from "./components/pages/Report/DailySalesSummary";
import Stock from "./components/pages/Report/Stock";
import StockTransfer from "./components/pages/Report/StockTransfer";
import CutomerDetails from "./components/pages/Report/CustomerDetails";
import PurchaseSummary from "./components/pages/Report/PurchaseSummary";
import DailySalesPaymentWise from "./components/pages/Report/DailySalesPaymentWise";
import KPIReport from "./components/pages/Report/KPIReport";
import BestSellerSales from "./components/pages/Report/BestSellerSales";
import RepairORReplacement from "./components/pages/Report/RepairORReplacement";
import Ledger from "./components/pages/Report/Ledger";
import CashBook from "./components/pages/Report/CashBook";
import CreditorDebitorReport from "./components/pages/Report/CreditorDebitor";
import SalesDetailsMonthly from "./components/pages/Report/SalesDetailsMonthly";
import StockCategoryWise from "./components/pages/Report/StockCategory";
import Salegstreport from "./components/pages/Report/SaleGST";
import SaleRegister from "./components/pages/Report/SaleRegister";

import SaleHSNCReport from "./components/pages/Report/SaleHSNC";
// OtherReport
import OtherDailySalesSummary from "./components/pages/otherbranch/OtherDailySalesSummary";
import OtherPurchaseSummary from "./components/pages/otherbranch/OtherPurchaseSummary";
import OtherStock from "./components/pages/otherbranch/OtherStock";
import AjioStock from "./components/pages/otherbranch/AjioStock";
import OtherStockTransfer from "./components/pages/otherbranch/OtherStockTransfer";
import OtherDSSPaymentWise from "./components/pages/otherbranch/OtherDSSPaymentWise";
import OtherKPIReport from "./components/pages/otherbranch/OtherKPIReport";
import OtherRepairORReplacement from "./components/pages/otherbranch/OtherRepairORReplacement";
import OtherCustomerDetails from "./components/pages/otherbranch/OtherCustomerDetails";
//repairandreplacement
import RepairAndReplacementIndex from "./components/pages/repairandreplacement/Index";
import RepairAndReplacementCreate from "./components/pages/repairandreplacement/Create";
import RepairAndReplacementDetails from "./components/pages/repairandreplacement/Details";
import RepairAndReplacementEdit from "./components/pages/repairandreplacement/Edit";
//JournalEntry
import JournelEntry from "./components/pages/JournalEntryPage/Create";
import JournelEntryIndex from "./components/pages/JournalEntryPage/Index";
import JournalEntryEdit from "./components/pages/JournalEntryPage/Edit";
import JournalEntryDetails from "./components/pages/JournalEntryPage/Details";
// Payment
import PaymentIndex from "./components/pages/Payment/Index";
import PaymentCreate from "./components/pages/Payment/Create";
import PaymentDetails from "./components/pages/Payment/Details";
import PaymentEdit from "./components/pages/Payment/Edit";
//Income Or Expense
import IncomeExpenseIndex from "./components/pages/IncomeExpense/Index";
import IncomeExpenseCreate from "./components/pages/IncomeExpense/Create";
import IncomeExpenseEdit from "./components/pages/IncomeExpense/Edit";
import IncomeExpenseDetails from "./components/pages/IncomeExpense/Details";
// Payment and Receipt
import PaymentAndReceiptIndex from "./components/pages/PaymentAndReceipt/Index";
import PaymentAndReceiptCreate from "./components/pages/PaymentAndReceipt/Create";
import PaymentAndReceiptDetails from "./components/pages/PaymentAndReceipt/Details";
import PaymentAndReceiptEdit from "./components/pages/PaymentAndReceipt/Edit";
// Home
import Home from "./components/pages/Home";
// CSS
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
// Loding
import LodingComponent from "./loding";
// Auth
import { AuthProvider, useAuth } from "./AuthContext";
// Logout
import Logout from "./Logout";
// Session Timeout
import SessionTimeout from "./SessionTimeout";
// Icons
import InventoryIcon from '@mui/icons-material/Inventory';
import PaymentsIcon from '@mui/icons-material/Payments';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentIcon from '@mui/icons-material/Payment';
import WalletIcon from '@mui/icons-material/Wallet';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LabelIcon from '@mui/icons-material/Label';
import ArticleIcon from '@mui/icons-material/Article';
import StoreIcon from '@mui/icons-material/Store';
import StyleIcon from '@mui/icons-material/Style';
import PersonIcon from '@mui/icons-material/Person';
import Person2Icon from '@mui/icons-material/Person2';
import ContactsIcon from '@mui/icons-material/Contacts';
import ListAltIcon from '@mui/icons-material/ListAlt';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { Link as MuiLink } from '@mui/material';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SecurityIcon from '@mui/icons-material/Security';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import BuildIcon from '@mui/icons-material/Build';
import PostAddIcon from '@mui/icons-material/PostAdd';
import TimelineOutlinedIcon from '@material-ui/icons/TimelineOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [otherOpen, setOtherOpen] = useState(false);
  const [accountOpen, setAccountsOpen] = useState(false);
  const [userOpen, setuserOpen] = useState(false);
  const [itemOpen, setItemOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };

  const handleOtherClick = () => {
    setOtherOpen(!otherOpen);
  };


  const handleAccountsClick = () => {
    setAccountsOpen(!accountOpen);
  };

  const handleUserClick = () => {
    setuserOpen(!userOpen);
  };

  const handleItemClick = () => {
    setItemOpen(!itemOpen);
  };

  const { companyName, companyId, isSuperAdmin, superCompanyId, roleName, branchId } = useAuth();

  const sectionTitleStyle = {
    color: "#27445D",
    fontFamily: "monospace",
    fontWeight: "bold",
    fontSize: "16px",
    letterSpacing: "0.5px",
  };

  const linkTextStyle = {
    marginLeft: "8px",
    color: "#333",
    fontFamily: "monospace",
    fontSize: "14px",
    textTransform: "uppercase",
  };

  return (
    <Router>
      <AuthProvider>
        <SessionTimeout />

        <AppBar position="static" style={{ backgroundColor: '#1A1A19', height: '45px' }}>
          <Toolbar style={{ minHeight: '55px', padding: '0 24px', position: 'relative' }}>

            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
              <MenuIcon />
            </IconButton>

            <Typography component="div" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <Link to="/Home" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
                  <FiHome style={{ marginRight: '8px' }} />
                  <Typography component="div" style={{ marginLeft: '16px', fontWeight: 'bolder', position: 'relative', marginTop: '-5px', textTransform: 'uppercase', fontFamily: 'monospace' }}>
                    {companyName}
                  </Typography>
                </Link>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', gap: '10px' }}>
                <div className="white-icon" style={{ marginTop: '5px', marginLeft: '10px' }}>
                  <Logout />
                </div>
              </div>
            </Typography>

          </Toolbar>
        </AppBar>

        {roleName !== "Counter" && (
          <Drawer
            anchor="left"
            open={drawerOpen}
            onClose={handleDrawerClose}
            sx={{
              "& .MuiDrawer-paper": {
                width: 280,
                background: "#F9FAFB",
                borderRight: "1px solid #E5E7EB",
              },
            }}
          >
            {/* Company Name */}
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mt: 2,
                mb: 1,
                ml: 2,
                color: "#27445D",
                fontFamily: "monospace",
                textTransform: "uppercase",
              }}
            >
              {companyName}
            </Typography>

            <Divider />

            <List disablePadding>
              {/* MASTER */}
              {roleName !== "Accounts" && (
                <>
                  <ListItemButton onClick={handleMasterClick}>
                    <ListItemText primary="MASTER" primaryTypographyProps={sectionTitleStyle} />
                    {masterOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={masterOpen} timeout="auto" unmountOnExit>
                    <List sx={{ pl: 3 }}>
                      <ListItemButton
                        component={NavLink}
                        to="/BranchIndex"
                        onClick={handleDrawerClose}
                      >
                        <StoreIcon color="primary" fontSize="small" />
                        <ListItemText primary="Branch" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>

                      {(roleName === "SuperAdmin" || roleName === "CompanyAdmin") && (
                        <ListItemButton
                          component={NavLink}
                          to="/StyleIndex"
                          onClick={handleDrawerClose}
                        >
                          <StyleIcon sx={{ color: "darkcyan" }} fontSize="small" />
                          <ListItemText primary="Style" primaryTypographyProps={linkTextStyle} />
                        </ListItemButton>
                      )}

                      {(roleName === "SuperAdmin" || roleName === "CompanyAdmin") && (
                        <ListItemButton
                          component={NavLink}
                          to="/BrandIndex"
                          onClick={handleDrawerClose}
                        >
                          <GroupWorkIcon sx={{ color: "darkolivegreen" }} fontSize="small" />
                          <ListItemText primary="Brand" primaryTypographyProps={linkTextStyle} />
                        </ListItemButton>
                      )}

                      <ListItemButton component={NavLink} to="/ItemIndex" onClick={handleDrawerClose}>
                        <LabelIcon sx={{ color: "darkorange" }} fontSize="small" />
                        <ListItemText primary="Item" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>

                      <ListItemButton component={NavLink} to="/MasterIndex" onClick={handleDrawerClose}>
                        <PersonIcon fontSize="small" />
                        <ListItemText primary="Registration" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>

                      <ListItemButton
                        component={NavLink}
                        to="/SalesManIndex"
                        onClick={handleDrawerClose}
                      >
                        <ContactsIcon sx={{ color: "red" }} fontSize="small" />
                        <ListItemText primary="Sales Man" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                    </List>
                  </Collapse>
                </>
              )}

              {/* TRANSACTION */}
              {roleName !== "Accounts" && (
                <>
                  <ListItemButton onClick={handleItemClick}>
                    <ListItemText primary="TRANSACTION" primaryTypographyProps={sectionTitleStyle} />
                    {itemOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={itemOpen} timeout="auto" unmountOnExit>
                    <List sx={{ pl: 3 }}>
                      <ListItemButton
                        component={NavLink}
                        to="/NewPurchaseIndex"
                        onClick={handleDrawerClose}
                      >
                        <InventoryIcon sx={{ color: "green" }} fontSize="small" />
                        <ListItemText primary="Purchase" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton
                        component={NavLink}
                        to="/NewPurchaseReturnIndex"
                        onClick={handleDrawerClose}
                      >
                        <AssignmentReturnIcon sx={{ color: "blueviolet" }} fontSize="small" />
                        <ListItemText primary="Purchase Return" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton
                        component={NavLink}
                        to="/NewSaleIndex"
                        onClick={handleDrawerClose}
                      >
                        <AddShoppingCartIcon sx={{ color: "darkolivegreen" }} fontSize="small" />
                        <ListItemText primary="Sale" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton
                        component={NavLink}
                        to="/SaleReturnIndex"
                        onClick={handleDrawerClose}
                      >
                        <RemoveShoppingCartIcon sx={{ color: "darkorange" }} fontSize="small" />
                        <ListItemText primary="Sale Return" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                    </List>
                  </Collapse>
                </>
              )}

              {/* ACCOUNTS */}
              <ListItemButton onClick={handleAccountsClick}>
                <ListItemText primary="ACCOUNTS" primaryTypographyProps={sectionTitleStyle} />
                {accountOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={accountOpen} timeout="auto" unmountOnExit>
                <List sx={{ pl: 3 }}>
                  <ListItemButton component={NavLink} to="/JournelEntryIndex" onClick={handleDrawerClose}>
                    <PostAddIcon sx={{ color: "#BE5985" }} fontSize="small" />
                    <ListItemText primary="Journal Entry" primaryTypographyProps={linkTextStyle} />
                  </ListItemButton>
                  <ListItemButton
                    component={NavLink}
                    to="/IncomeExpenseIndex"
                    onClick={handleDrawerClose}
                  >
                    <TimelineOutlinedIcon sx={{ color: "#626F47" }} fontSize="small" />
                    <ListItemText primary="Income / Expense" primaryTypographyProps={linkTextStyle} />
                  </ListItemButton>
                  <ListItemButton component={NavLink} to="/PaymentIndex" onClick={handleDrawerClose}>
                    <PaymentIcon sx={{ color: "#78B3CE" }} fontSize="small" />
                    <ListItemText primary="Payment" primaryTypographyProps={linkTextStyle} />
                  </ListItemButton>
                  <ListItemButton
                    component={NavLink}
                    to="/PaymentAndReceiptIndex"
                    onClick={handleDrawerClose}
                  >
                    <AccountBalanceIcon sx={{ color: "#3B1C32" }} fontSize="small" />
                    <ListItemText primary="Payment & Receipt" primaryTypographyProps={linkTextStyle} />
                  </ListItemButton>
                </List>
              </Collapse>

              {/* REPORT */}
              {roleName !== "Accounts" && (
                <>
                  <ListItemButton onClick={handleReportClick}>
                    <ListItemText primary="REPORT" primaryTypographyProps={sectionTitleStyle} />
                    {reportOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={reportOpen} timeout="auto" unmountOnExit>
                    <List sx={{ pl: 3 }}>
                      <ListItemButton component={NavLink} to="/DailySalesSummary" onClick={handleDrawerClose}>
                        <InventoryIcon sx={{ color: "blueviolet" }} fontSize="small" />
                        <ListItemText primary="DSS" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton component={NavLink} to="/DailySalesPaymentWise" onClick={handleDrawerClose}>
                        <PaymentsIcon sx={{ color: "darkseagreen" }} fontSize="small" />
                        <ListItemText primary="DSS Payment Wise" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton component={NavLink} to="/CashBook" onClick={handleDrawerClose}>
                        <CurrencyRupeeIcon sx={{ color: "darkseagreen" }} fontSize="small" />
                        <ListItemText primary="Cash Book" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton component={NavLink} to="/CreditorDebitorReport" onClick={handleDrawerClose}>
                        <SummarizeIcon sx={{ color: "#987070" }} fontSize="small" />
                        <ListItemText primary="Creditors/Debitors" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton component={NavLink} to="/Stock" onClick={handleDrawerClose}>
                        <SummarizeIcon sx={{ color: "darkorange" }} fontSize="small" />
                        <ListItemText primary="Consolidated Stock" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton component={NavLink} to="/PurchaseSummary" onClick={handleDrawerClose}>
                        <LibraryBooksIcon sx={{ color: "darkolivegreen" }} fontSize="small" />
                        <ListItemText primary="Purchase Summary" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton component={NavLink} to="/SalesDetailsMonthly" onClick={handleDrawerClose}>
                        <ArticleIcon sx={{ color: "darkgreen" }} fontSize="small" />
                        <ListItemText primary="Monthly Sales" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton component={NavLink} to="/Ledger" onClick={handleDrawerClose}>
                        <SummarizeIcon sx={{ color: "darkgreen" }} fontSize="small" />
                        <ListItemText primary="Ledger" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton component={NavLink} to="/CutomerDetails" onClick={handleDrawerClose}>
                        <PersonIcon sx={{ color: "darkcyan" }} fontSize="small" />
                        <ListItemText primary="Customer Data" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton component={NavLink} to="/StockCategoryWise" onClick={handleDrawerClose}>
                        <LibraryBooksIcon sx={{ color: "darkseagreen" }} fontSize="small" />
                        <ListItemText primary="Stock Category Wise" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>

                      <ListItemButton component={NavLink} to="/SaleHSNCReport" onClick={handleDrawerClose} >
                        <ArticleIcon sx={{ color: '#B4B4B8' }} fontSize="small" />
                        <ListItemText primary="Sale HSNC (Accounts)" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>

                      <ListItemButton component={NavLink} to="/Salegstreport" onClick={handleDrawerClose} >
                        <ArticleIcon sx={{ color: '#B1C29E' }} fontSize="small" />
                        <ListItemText primary="Sale GST (Accounts)" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton component={NavLink} to="/SaleRegister" onClick={handleDrawerClose}>
                        <ArticleIcon sx={{ color: "darkgreen" }} fontSize="small" />
                        <ListItemText primary="Sale Register (Accounts)" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                    </List>
                  </Collapse>
                </>
              )}

              {/* BRANCH REPORT */}
              {(roleName === "Accounts" || roleName === "SuperAdmin" || companyId === "1009") && (
                <>
                  <ListItemButton onClick={handleOtherClick}>
                    <ListItemText primary="BRANCH REPORT" primaryTypographyProps={sectionTitleStyle} />
                    {otherOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={otherOpen} timeout="auto" unmountOnExit>
                    <List sx={{ pl: 3 }}>
                      <ListItemButton component={NavLink} to="/OtherDailySalesSummary" onClick={handleDrawerClose}>
                        <InventoryIcon sx={{ color: "blueviolet" }} fontSize="small" />
                        <ListItemText primary="DSS" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton component={NavLink} to="/OtherDSSPaymentWise" onClick={handleDrawerClose}>
                        <PaymentsIcon sx={{ color: "darkseagreen" }} fontSize="small" />
                        <ListItemText primary="DSS Payment Wise" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton component={NavLink} to="/OtherStock" onClick={handleDrawerClose}>
                        <SummarizeIcon sx={{ color: "darkorange" }} fontSize="small" />
                        <ListItemText primary="Consolidated Stock" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton component={NavLink} to="/OtherPurchaseSummary" onClick={handleDrawerClose}>
                        <LibraryBooksIcon sx={{ color: "darkolivegreen" }} fontSize="small" />
                        <ListItemText primary="Purchase Summary" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                      <ListItemButton component={NavLink} to="/OtherCustomerDetails" onClick={handleDrawerClose}>
                        <PersonIcon sx={{ color: "darkcyan" }} fontSize="small" />
                        <ListItemText primary="Customer Data" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                    </List>
                  </Collapse>
                </>
              )}

              {/* USER */}
              <>
                <ListItemButton onClick={handleUserClick}>
                  <ListItemText primary="USER" primaryTypographyProps={sectionTitleStyle} />
                  {userOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={userOpen} timeout="auto" unmountOnExit>
                  <List sx={{ pl: 3 }}>
                    {roleName === "SuperAdmin" && (
                      <ListItemButton component={NavLink} to="/UserIndex" onClick={handleDrawerClose}>
                        <PeopleAltIcon sx={{ color: "blueviolet" }} fontSize="small" />
                        <ListItemText primary="User" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                    )}
                    {roleName === "SuperAdmin" && (
                      <ListItemButton component={NavLink} to="/RoleIndex" onClick={handleDrawerClose}>
                        <AccessibilityIcon sx={{ color: "darkorange" }} fontSize="small" />
                        <ListItemText primary="Role" primaryTypographyProps={linkTextStyle} />
                      </ListItemButton>
                    )}
                    <ListItemButton component={NavLink} to="/PasswordChange" onClick={handleDrawerClose}>
                      <SecurityIcon sx={{ color: "darkolivegreen" }} fontSize="small" />
                      <ListItemText primary="Change Password" primaryTypographyProps={linkTextStyle} />
                    </ListItemButton>
                  </List>
                </Collapse>
              </>

            </List>
          </Drawer>
        )}
        <Container maxWidth="xl">
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/Home" exact component={Home} />
            {/* Company */}
            <Route path="/CompanyIndex" component={CompanyIndex} />
            <Route path="/CompanyCreate" component={CompanyCreate} />
            <Route path="/CompanyEdit/:id" component={CompanyEdit} />
            {/* Branch */}
            <Route path="/BranchIndex" component={BranchIndex} />
            <Route path="/BranchCreate" component={BranchCreate} />
            <Route path="/BranchEdit/:id" component={BranchEdit} />
            {/* Style */}
            <Route path="/StyleIndex" component={StyleIndex} />
            <Route path="/StyleCreate" component={StyleCreate} />
            <Route path="/StyleEdit/:id" component={StyleEdit} />
            {/* Brand */}
            <Route path="/BrandIndex" component={BrandIndex} />
            <Route path="/BrandCreate" component={BrandCreate} />
            <Route path="/BrandEdit/:id" component={BrandEdit} />
            {/* Item */}
            <Route path="/ItemIndex" component={ItemIndex} />
            <Route path="/ItemCreate" component={ItemCreate} />
            <Route path="/ItemEdit/:id" component={ItemEdit} />
            {/* Master  */}
            <Route path="/MasterIndex" component={MasterIndex} />
            {/* Masteredit id as masterId and mtypeid as masterTypeid  */}
            <Route path="/CapitalEdit/:id/:mid" component={CapitalEdit} />
            {/* User */}
            <Route path="/UserIndex" component={UserIndex} />
            <Route path="/UserCreate" component={UserCreate} />
            <Route path="/UserEdit/:id" component={UserEdit} />
            <Route path="/UserDetail/:id" component={UserDetail} />
            <Route path="/PasswordChange" component={PasswordChange} />
            {/* Role */}
            <Route path="/RoleIndex" component={RoleIndex} />
            <Route path="/RoleDetail/:id" component={RoleDetail} />
            {/* SalesMan */}
            <Route path="/SalesManIndex" component={SalesManIndex} />
            <Route path="/SalesManCreate" component={SalesManCreate} />
            <Route path="/SalesManEdit/:id" component={SalesManEdit} />
            {/* Purchase */}
            <Route path="/PurchaseIndex" component={PurchaseIndex} />
            <Route path="/PurchaseCreate" component={PurchaseCreate} />
            <Route path="/PurchaseEdit/:id" component={PurchaseEdit} />
            <Route path="/PurchaseDetails/:id" component={PurchaseDetails} />
            {/* New Purchase */}
            <Route path="/NewPurchaseIndex" component={NewPurchaseIndex} />
            <Route path="/NewPurchaseCreate" component={NewPurchaseCreate} />
            <Route path="/NewPurchaseEdit/:id" component={NewPurchaseEdit} />
            <Route path="/NewPurchaseDetails/:id" component={NewPurchaseDetails} />
            {/* Purchase Return*/}
            <Route path="/PurchaseReturnIndex" component={PurchaseReturnIndex} />
            <Route path="/PurchaseReturnCreate/:id" component={PurchaseReturnCreate} />
            <Route path="/PurchaseReturnEdit/:id" component={PurchaseReturnEdit} />
            <Route path="/PurchaseReturnDetails/:id" component={PurchaseReturnDetails} />
            {/* New Purchase Return*/}
            <Route path="/NewPurchaseReturnIndex" component={NewPurchaseReturnIndex} />
            <Route path="/NewPurchaseReturnCreate/:id" component={NewPurchaseReturnCreate} />
            <Route path="/NewPurchaseReturnEdit/:id" component={NewPurchaseReturnEdit} />
            <Route path="/NewPurchaseReturnDetails/:id" component={NewPurchaseReturnDetails} />
            {/* Sale */}
            {/* <Route path="/SaleIndex" component={SaleIndex} />
            <Route path="/SaleCreate" component={SaleCreate} />
            <Route path="/SaleEdit/:id" component={SaleEdit} />
            <Route path="/SaleDetails/:id" component={SaleDetails} />
            {/* New Sale */}
            <Route path="/NewSaleIndex" component={NewSaleIndex} />
            <Route path="/NewSaleCreate" component={NewSaleCreate} />
            <Route path="/NewSaleEdit/:id" component={NewSaleEdit} />
            <Route path="/NewSaleDetails/:id" component={NewSaleDetails} />
            {/* Sale Return*/}
            <Route path="/SaleReturnIndex" component={SaleReturnIndex} />
            <Route path="/SaleReturnCreate" component={SaleReturnCreate} />
            <Route path="/SaleReturnEdit/:id" component={SaleReturnEdit} />
            <Route path="/SaleReturnDetails/:id" component={SaleReturnDetails} />
            {/* Stock Transfer*/}
            <Route path="/StockTransferIndex" component={StockTransferIndex} />
            <Route path="/StockTransferCreate" component={StockTransferCreate} />
            <Route path="/StockTransferEdit/:id" component={StockTransferEdit} />
            <Route path="/StockIn" component={StockIn} />
            <Route path="/StockInDetail/:id" component={StockInDetail} />
            <Route path="/StockTransferDetails/:id" component={StockTransferDetails} />
            <Route path="/StockInCreate" component={StockInCreate} />
            <Route path="/StockTransferEcommCreate" component={StockTransferEcommCreate} />
            <Route path="/StockInPending/:id" component={StockInPending} />
            {/* Replacement*/}
            <Route path="/ReplacementIndex" component={ReplacementIndex} />
            <Route path="/ReplacementCreate" component={ReplacementCreate} />
            <Route path="/ReplacementEdit/:id" component={ReplacementEdit} />
            <Route path="/ReplacementDetails/:id" component={ReplacementDetails} />
            {/* Report*/}
            <Route path="/DailySalesSummary" component={DailySalesSummary} />
            <Route path="/Stock" component={Stock} />
            <Route path="/StockTransfer" component={StockTransfer} />
            <Route path="/CutomerDetails" component={CutomerDetails} />
            <Route path="/PurchaseSummary" component={PurchaseSummary} />
            <Route path="/DailySalesPaymentWise" component={DailySalesPaymentWise} />
            <Route path="/KPIReport" component={KPIReport} />
            <Route path="/BestSellerSales" component={BestSellerSales} />
            <Route path="/RepairORReplacement" component={RepairORReplacement} />
            <Route path="/Ledger" component={Ledger} />
            <Route path="/CashBook" component={CashBook} />
            <Route path="/CreditorDebitorReport" component={CreditorDebitorReport} />
            <Route path="/SalesDetailsMonthly" component={SalesDetailsMonthly} />
            <Route path="/StockCategoryWise" component={StockCategoryWise} />
            <Route path="/SaleHSNCReport" component={SaleHSNCReport} />
            <Route path="/Salegstreport" component={Salegstreport} />
            <Route path="/SaleRegister" component={SaleRegister} />

            {/* Other Report*/}
            <Route path="/OtherDailySalesSummary" component={OtherDailySalesSummary} />
            <Route path="/OtherPurchaseSummary" component={OtherPurchaseSummary} />
            <Route path="/OtherStock" component={OtherStock} />
            <Route path="/AjioStock" component={AjioStock} />
            <Route path="/OtherStockTransfer" component={OtherStockTransfer} />
            <Route path="/OtherDSSPaymentWise" component={OtherDSSPaymentWise} />
            <Route path="/OtherKPIReport" component={OtherKPIReport} />
            <Route path="/OtherRepairORReplacement" component={OtherRepairORReplacement} />
            <Route path="/OtherCustomerDetails" component={OtherCustomerDetails} />
            {/* RepairAndReplacement*/}
            <Route path="/RepairAndReplacementIndex" component={RepairAndReplacementIndex} />
            <Route path="/RepairAndReplacementCreate" component={RepairAndReplacementCreate} />
            <Route path="/RepairAndReplacementDetails/:id" component={RepairAndReplacementDetails} />
            <Route path="/RepairAndReplacementEdit/:id" component={RepairAndReplacementEdit} />
            {/* JournalEntry */}
            <Route path="/JournelEntry" component={JournelEntry} />
            <Route path="/JournelEntryIndex" component={JournelEntryIndex} />
            <Route path="/JournalEntryEdit/:id" component={JournalEntryEdit} />
            <Route path="/JournalEntryDetails/:id" component={JournalEntryDetails} />
            {/* Payment */}
            <Route path="/PaymentIndex" component={PaymentIndex} />
            <Route path="/PaymentCreate" component={PaymentCreate} />
            <Route path="/PaymentDetails/:id" component={PaymentDetails} />
            <Route path="/PaymentEdit/:id" component={PaymentEdit} />
            {/* Income Or Expense */}
            <Route path="/IncomeExpenseIndex" component={IncomeExpenseIndex} />
            <Route path="/IncomeExpenseCreate" component={IncomeExpenseCreate} />
            <Route path="/IncomeExpenseEdit/:id" component={IncomeExpenseEdit} />
            <Route path="/IncomeExpenseDetails/:id" component={IncomeExpenseDetails} />
            {/* Payment And Receipt */}
            <Route path="/PaymentAndReceiptIndex" component={PaymentAndReceiptIndex} />
            <Route path="/PaymentAndReceiptCreate" component={PaymentAndReceiptCreate} />
            <Route path="/PaymentAndReceiptDetails/:id" component={PaymentAndReceiptDetails} />
            <Route path="/PaymentAndReceiptEdit/:id" component={PaymentAndReceiptEdit} />

          </Switch>
        </Container>

      </AuthProvider >
    </Router>
  );
};

export default App;

